export enum HiddenFeatures {
  DEVIS = 'DEVIS',
  MULTIFLOW = 'MULTIFLOW',
}

const envService = {
  isFeatureHidden: (feature: HiddenFeatures): boolean =>
    !!process.env.REACT_APP_HIDDEN_FEATURES &&
    process.env.REACT_APP_HIDDEN_FEATURES.split(',')
      .map((f) => f.trim().toUpperCase())
      .includes(feature),
};

export default envService;
